export default "__VITE_PUBLIC_ASSET__90d32192__"